import React, { FunctionComponent } from "react";
import { ComponentProps } from "../components/component-props";
import { Demo } from "../components/demo";

const textButtonDemo = {
    code: "<TextButton>Click me!</TextButton>"
};

export const TextButtonDemo: FunctionComponent = () => {
    return (
        <Demo demo={textButtonDemo}>
            <ComponentProps componentName="TextButton" />
        </Demo>
    );
};

const iconButtonDemo = {
    code: "<IconButton icon={<SearchIcon />} />"
};

export const IconButtonDemo: FunctionComponent = () => {
    return <Demo demo={iconButtonDemo}>
        <ComponentProps componentName="IconButton" />
    </Demo>;
};

const iconToggleDemo = {
    code: `<IconToggle
    icon={<ChevronLeftIcon />}
    onIcon={<ChevronRightIcon />} />`
};

export const IconToggleDemo: FunctionComponent = () => {
    return <Demo demo={iconToggleDemo}>
        <ComponentProps componentName="IconToggle" />
    </Demo>;
};

const toggleButtonDemo = {
    noInline: true,
    code:
`const ToggleButtonDemo = () => {
    const VIEW_TYPE = {
        GRID: 0,
        LIST: 1,
        PREVIEW: 2
    }

    const [value, setValue] = React.useState(VIEW_TYPE.GRID);
    return (
        <ToggleButtonGroup>
            <ToggleButton
                checked={value === VIEW_TYPE.GRID}
                icon={<AppsIcon />}
                title="Show grid view"
                onChange={() => setValue(VIEW_TYPE.GRID)}
            />
            <ToggleButton
                checked={value === VIEW_TYPE.LIST}
                icon={<ListIcon />}
                title="Show table view"
                onChange={() => setValue(VIEW_TYPE.LIST)}
            />
            <ToggleButton
                checked={value === VIEW_TYPE.PREVIEW}
                icon={<VisibilityIcon />}
                title="Show preview"
                onChange={() => setValue(VIEW_TYPE.PREVIEW)}
            />
        </ToggleButtonGroup>
    );
}

render(<ToggleButtonDemo />);`
};

export const ToggleButtonDemo: FunctionComponent = () => {
    return <Demo demo={toggleButtonDemo}>
        <ComponentProps componentName="ToggleButtonGroup" />
        <ComponentProps componentName="ToggleButton" />
    </Demo>;
};
